import type { ChartableKind } from './chartableColumns';

export type ColumnChartType = 'horizontalBar' | 'verticalBar' | 'donut';

export interface ColumnChartTypeOption {
  value: ColumnChartType;
  label: string;
}

const ALL_CHART_TYPES: ColumnChartTypeOption[] = [
  { value: 'horizontalBar', label: 'Horizontal bars' },
  { value: 'verticalBar', label: 'Vertical bars' },
  { value: 'donut', label: 'Donut' },
];

export function getColumnChartTypeOptions(): ColumnChartTypeOption[] {
  return ALL_CHART_TYPES;
}

export function getDefaultColumnChartType(kind: ChartableKind): ColumnChartType {
  if (kind === 'categorical') return 'horizontalBar';
  return 'verticalBar';
}

export function isColumnChartType(value: unknown): value is ColumnChartType {
  return value === 'horizontalBar' || value === 'verticalBar' || value === 'donut';
}

export function resolveColumnChartType(value: unknown, kind: ChartableKind | undefined): ColumnChartType {
  if (isColumnChartType(value)) return value;
  return kind ? getDefaultColumnChartType(kind) : 'verticalBar';
}
